// Export all services
import { Api } from "./MainService";
import { AuthApi } from "./auth/auth.api";
import { ChatApi } from "./chat/chat.api";
import { DocumentsApi } from "./documents/documents.api";
import { ParentApi } from "./parent/parent.api";
import { PaymentApi } from "./payment/payment.api";
import { SttTtsApi } from "./sttTts/sttTts.api";

// Initialize the main API instance
const api = new Api();

// Initialize all API services
const authApi = new AuthApi(api);
const chatApi = new ChatApi(api);
const documentsApi = new DocumentsApi(api);
const parentApi = new ParentApi(api);
const paymentApi = new PaymentApi(api);
const sttTtsApi = new SttTtsApi(api);

export {
  api,
  authApi,
  chatApi,
  documentsApi,
  parentApi,
  paymentApi,
  sttTtsApi,
};

export * from "./MainService";
export * from "./auth/auth.api";
export * from "./chat/chat.api";
export * from "./documents/documents.api";
export * from "./parent/parent.api";
export * from "./payment/payment.api";
export * from "./sttTts/sttTts.api";
export { UserApi, userService } from "./user/user.api";
